import { NetType } from "@/modules/deposit/store/value";
import { create } from "zustand";

interface ValueStore {
  value: string;
  currentToken: "ton" | "token" | "";
  net: NetType;
  setValue: (value: string) => void;
  setCurrentToken: (token: "ton" | "token" | "") => void;
  setNet: (net: NetType) => void;
}

export const useMatchingBonusValueStore = create<ValueStore>((set) => ({
  value: "0",
  currentToken: "",
  net: "ton",
  setValue: (value) => set({ value }),
  setCurrentToken: (token: "ton" | "token" | "") =>
    set({ currentToken: token }),
  setNet: (net: NetType) => set({ net }),
}));
